'use strict';

var React = require('react');

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * This is intended to add callbacks dynamically without sending a new function to the children on each render.
 * The returned function creates a new callback each time is called with a different parameter.
 * If the parameter had been already used, the same function is returned.
 * When the inputs change, al functions are renewed to use the new callback.
 *
 * The returned function is a wrapper of the callback, which when called, calls the callback with the id with which it was
 * created as first parameter, and the rest of the received arguments as the following parameters.
 *
 *
 * @param callback
 * @param inputs
 * @returns {function(*=): *}
 */

var useCallbackCreator = function useCallbackCreator(callback, inputs) {
  var callbacks = React.useRef({});
  React.useMemo(function () {
    var _loop = function _loop(id) {
      callbacks.current[id].func = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return callback.apply(void 0, [callbacks.current[id].id].concat(_toConsumableArray(callbacks.current[id].savedArgs), args));
      };
    };

    for (var id in callbacks.current) {
      _loop(id);
    } // eslint-disable-next-line

  }, inputs);
  return React.useCallback(function (id) {
    for (var _len2 = arguments.length, savedArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      savedArgs[_key2 - 1] = arguments[_key2];
    }

    if (!callbacks.current[id]) {
      callbacks.current[id] = {
        id: id,
        savedArgs: savedArgs,
        func: function func() {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          return callback.apply(void 0, [id].concat(savedArgs, args));
        }
      }; // The id is saved inside the object to preserve its type
    }

    return callbacks.current[id].func; // eslint-disable-next-line
  }, inputs);
};

module.exports = useCallbackCreator;
//# sourceMappingURL=index.js.map
